import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { WarehouseProductType } from '../../enums/warehouse-product-type';
import { QuantityUnit } from '@web/shared/module/measurement';

@jsonObject
export class WarehouseProductUpdateRequest {
  @jsonMember(String)
  public readonly type!: WarehouseProductType;

  @jsonMember(Number)
  public readonly quantity!: number;

  @jsonMember(String)
  public readonly quantityUnit!: QuantityUnit;

  @jsonMember(String)
  public readonly sku!: string;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly ownerId!: Guid;

  @jsonMember(String)
  public readonly brandId!: Guid;

  @jsonMember(String)
  public readonly localisationId?: Nillable<Guid>;

  @jsonMember(Boolean)
  public readonly promotion!: boolean;

  @jsonMember(String)
  public readonly durabilityInformation!: string;

  @jsonMember(String)
  public readonly measure!: string;

  public constructor(
    type: WarehouseProductType,
    quantity: number,
    quantityUnit: QuantityUnit,
    sku: string,
    name: string,
    ownerId: Guid,
    brandId: Guid,
    localisationId: Nillable<Guid>,
    promotion: boolean,
    durabilityInformation: string,
    measure: string,
  ) {
    this.type = type;
    this.quantity = quantity;
    this.quantityUnit = quantityUnit;
    this.sku = sku;
    this.name = name;
    this.ownerId = ownerId;
    this.brandId = brandId;
    this.localisationId = localisationId;
    this.promotion = promotion;
    this.durabilityInformation = durabilityInformation;
    this.measure = measure;
  }
}
